import { render, staticRenderFns } from "./DeletePaymentModal.vue?vue&type=template&id=6a30ce1b&scoped=true&class=fill-height&"
import script from "./DeletePaymentModal.vue?vue&type=script&lang=ts&"
export * from "./DeletePaymentModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePaymentModal.vue?vue&type=style&index=0&id=6a30ce1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30ce1b",
  null
  
)

export default component.exports